module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KP-9c82de0fa95c05e4c2489573da6b18c4.png";